import { render } from "./GridIndexPage.vue?vue&type=template&id=20f90c1c&scoped=true"
import script from "./GridIndexPage.vue?vue&type=script&lang=js"
export * from "./GridIndexPage.vue?vue&type=script&lang=js"

import "./GridIndexPage.vue?vue&type=style&index=0&id=20f90c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f90c1c"]])

export default __exports__